import { render, staticRenderFns } from "./positiveExamine.vue?vue&type=template&id=0c6f2dff&scoped=true"
import script from "./positiveExamine.vue?vue&type=script&lang=js"
export * from "./positiveExamine.vue?vue&type=script&lang=js"
import style0 from "./positiveExamine.vue?vue&type=style&index=0&id=0c6f2dff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f2dff",
  null
  
)

export default component.exports